import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl} from 'appShared/classes/controls';
import {
    CurrencyTypesEnum,
    HttpStatusCodesEnum,
    MarketDataFeedBundleInputModel,
    MarketDataFeedBundleInterface,
    MarketDataFeedBundleModel,
    MarketDataFeedInterface,
    ServerResponse,
    ServerResponseData,
    SesHelper,
    SesService
} from '@spa/api';
import {Helper} from 'appShared/classes';
import {map} from 'rxjs/operators';
import {AddNewFeedToExistingBundleControls, FEEDID_CHECKBOX_PREFIX, prepareFeedCheckbox, } from 'appAssets/descriptors';
import {MarketDataFeedBundleFormErrorStatesEnum} from 'appEntries/panel/enums';
import {BaseMarketDataForm} from 'appShared/forms';

export class AddFeedExistingBundleForm extends BaseMarketDataForm {
    private readonly feeds: MarketDataFeedInterface[];
    private readonly bundle: MarketDataFeedBundleModel;

    constructor(
        sesService: SesService,
        feeds: MarketDataFeedInterface[],
        bundle: MarketDataFeedBundleModel,
    ) {
        super(sesService);
        this.feeds = feeds;
        this.bundle = bundle;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        const feedControls = AddNewFeedToExistingBundleControls();

        for (const feed of this.feeds) {
            feedControls.push(prepareFeedCheckbox(feed));
        }

        this.controls = feedControls.map((control: BaseControl) => {
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });

    }

    createRequest(): ServerResponse<boolean> {

        const selectedFeedIds: number[] = [];

        for (const property in this.formGroup.value) {
            if (property.startsWith(FEEDID_CHECKBOX_PREFIX) && this.formGroup.value[property] > 0) {
                selectedFeedIds.push(this.formGroup.value[property]);
            }
        }

        if (selectedFeedIds.length === 0) {
            return Helper.errorsHelper().createBadRequestResponseObservable(
                MarketDataFeedBundleFormErrorStatesEnum.CreateMarketDataFeedBundleFailedNoFeed
            );
        }

        const currentFeedList = this.bundle.feedList.map(feed => feed.id);

        const model = new MarketDataFeedBundleInputModel(
            this.bundle.name,
            this.bundle.description,
            SesHelper.getPriceCurrency(this.bundle.priceList),
            this.bundle.priceList[0]?.defaultProPrice,
            this.bundle.priceList[0]?.defaultNonProPrice,
            this.bundle.priceList[0]?.alaricInternalPrice,
            this.bundle.priceList[0]?.alaricNonProPrice,
            this.bundle.priceList[0]?.alaricProPrice,
            selectedFeedIds.concat(...currentFeedList),
            this.bundle.platformFrontend?.id
        );

        return this.sesService.updateMarketDataFeedBundle(this.bundle.id, model).pipe(
            map((registerResponse: ServerResponseData<MarketDataFeedBundleInterface>) => {
                if (registerResponse.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<MarketDataFeedBundleInterface>(
                        registerResponse,
                        MarketDataFeedBundleFormErrorStatesEnum.CreateMarketDataFeedBundleFailed
                    );
                }

                return Helper.createSuccessResponse<boolean>(true);
            })
        );
    }
}
